import { format, parse } from 'date-fns';
import { urlUtils } from '../utils/url';

export const hotelOnlyModel = {
  get resortCaId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get resortWvId() {
    return urlUtils.getResortWvIdFromUrl();
  },
  get checkInDate() {
    const checkInDateFromUrl = urlUtils.getCheckInDateFromUrl();
    if (!checkInDateFromUrl) return null;

    const checkInDate = parse(checkInDateFromUrl, 'yyyyMMdd', new Date());
    return format(checkInDate, 'yyyy-MM-dd');
  },
  get checkoutDate() {
    const checkOutDateFromUrl = urlUtils.getCheckOutDateFromUrl();
    if (!checkOutDateFromUrl) return null;

    const checkOutDate = parse(checkOutDateFromUrl, 'yyyyMMdd', new Date());
    return format(checkOutDate, 'yyyy-MM-dd');
  },
  get Rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get QueryUnits() {
    return urlUtils.getUnitsFromUrl();
  },
};

export const hotelOnlyPriceMatrix = {
  get resortCaId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get resortWvId() {
    return urlUtils.getResortWvIdFromUrl();
  },
  get hotelWvId() {
    return urlUtils.getHotelWvIdFromUrl();
  },
  get checkInDate() {
    const checkInDateFromUrl = urlUtils.getCheckInDateFromUrl();
    if (!checkInDateFromUrl) return null;

    const checkInDate = parse(checkInDateFromUrl, 'yyyyMMdd', new Date());
    return format(checkInDate, 'yyyy-MM-dd');
  },
  get checkoutDate() {
    const checkOutDateFromUrl = urlUtils.getCheckOutDateFromUrl();
    if (!checkOutDateFromUrl) return null;

    const checkOutDate = parse(checkOutDateFromUrl, 'yyyyMMdd', new Date());
    return format(checkOutDate, 'yyyy-MM-dd');
  },
  get Rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get hotelCode() {
    return urlUtils.getHotelCodeFromUrl();
  },
  get selectedKey() {
    return urlUtils.getAccommodationKeyFromUrl();
  },
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
};
